(function () {
    'use strict'

    angular.module('MktzapApp.Factories')
        .factory('CustomerSatisfactionSurveyService', CustomerSatisfactionSurveyService);

    CustomerSatisfactionSurveyService.$inject = ['$resource'];

    function CustomerSatisfactionSurveyService($resource) {
        return $resource('', {}, {
            paged: {
                url: apiUrl + '/reports/customer-satisfaction-survey-search',
                method: 'GET',
                params: {},
                isArray: false
            }
        })
    }
})();
